/**
 * useReleaseInCarico — F-007 Phase 4 (IMPL-P4-004).
 *
 * Mutation per rilasciare una pratica precedentemente presa in carico
 * (`POST /:id/release`). La pratica torna in `INVIATA` e gli assignment
 * fields lato server vengono ripuliti.
 *
 * Invalida queue + my-assigned al completamento.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { operatorClient } from '../lib/operator-client';

export function useReleaseInCarico() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (praticaId: string) => operatorClient.release(praticaId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['operator', 'queue'] });
      qc.invalidateQueries({ queryKey: ['operator', 'my-assigned'] });
    },
  });
}
